// import { parseString } from 'xml2js';
import { SessionError } from './session.error';
interface Session {
  baseUrl: string;
  groupId: string;
  apiKey: string;
  visitorId: string;
  start: number;
  end: number;
  puid: string;
}

type SessionParams = {
  camera: string;
  resolution: string;
};

interface SessionConfig {
  baseUrl: string;
  groupId: number | string;
  puid: string;
  loginKey: string;
}

interface Invite {
  sessionType: number;
  smsPhone: string;
  agentName: string;
  sessionParams: SessionParams;
}

export const getSessionData = async (
  session: Session
): Promise<Record<string, unknown>> => {
  try {
    //is not used in the codebase
    const url = `${session.baseUrl}
              /services/activityservice.asmx/PartnerUserSessions
              ?partnerId=${session.groupId}
              &apiKey=${session.apiKey}
              &partnerUserId=${session.puid}
              &startRange=${session.start}
              &endRange=${session.end}
              &status=C`;

    const response = await fetch(url);
    const xml = response.text();
    // return parseString(xml, (err: Error, results: {}) =>
    //   JSON.stringify(results)
    // );
    return {};
  } catch (e: any) {
    throw new SessionError(e.cause);
  }
};

export const sessionInvite = async (
  config: SessionConfig,
  invite: Invite
): Promise<{
  invitationText: string;
  sessionKey: string;
}> => {
  const url = `https://${config.baseUrl}/api/SessionInvitation/smsInvite?groupid=${config.groupId}`;
  const headers = {
    Authorization: `Bearer GKEY ${config.groupId}&${encodeURIComponent(
      config.puid
    )}&${config.loginKey}`,
    'Content-Type': 'application/json',
  };

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(invite),
  });

  // NOTE: fetch only throws connection / transport errors
  if (response?.ok) {
    const result = response.json();
    return result;
  } else {
    // NOTE: here we're resolving external service reply, but if we need a custom handling - we need to extend Error with our CustomError type
    const rejectReason = new Error('ExternalServiceError');
    if (response?.status) {
      const responseDetails = await response.json();
      if (
        ['ExternalError', 'InvalidParameter'].includes(responseDetails?.code)
      ) {
        rejectReason.name = 'ExternalServiceHandledError';
        rejectReason.message = responseDetails?.detail;
      }
    }
    return new Promise((resolve, reject) => {
      reject(rejectReason);
    });
  }
};
